export default __webpack_public_path__ + "static/media/grafema_angura_06.792ce463.jpg";